
<template>
    <div class="animated fadeIn equipmentList contract-sla bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="sla"
                        arrows >
                    <template slot="gofixTab:sla">
                        <gofix-card title="Priority" >
                            <template slot="gofixCard:right_header">
                                <div class="d-flex justify-content-end align-items-center">
                                    <b-button title="Edit" v-b-tooltip.hover @click="$refs['modal-EditPrioritySet'].show()" class="btnFloat btnEditSla"><img src="img/iconPencil.png" alt=""></b-button>
                                </div>
                            </template>
                            <b-row class="content">
                                <b-col md="2" v-for="(priSet, index) in prioritySet && prioritySet.priority_options" :key="index">
                                    <gofix-text-field class="mb-3" :label="`#${index + 1}`" oneline>{{priSet}}</gofix-text-field>
                                </b-col>
                            </b-row>
                        </gofix-card>
                        <gofix-card title="SLA" fullContent class="mb-10" classHeader="mb-5 pl-23">
                            <gofix-default-table :settings="tableConfig"
                                :table-items="tableItems"
                                @load-items="getTableData"
                                @delete-items="deleteItems"
                                @new-item="newItem"
                                @row-click="detailItem"
                                ref="gofixTable">
                                <template slot="gofix_table:reaction_time_data" slot-scope="row">
                                    {{row.item.reaction_time_data  | formatMinutes }}
                                </template>
                                <template slot="gofix_table:response_time_data" slot-scope="row">
                                    {{row.item.response_time_data  | formatMinutes }}
                                </template>
                                <template slot="gofix_table:rectification_time_data" slot-scope="row">
                                    {{row.item.rectification_time_data  | formatMinutes }}
                                </template>
                                <template slot="gofix_table:admin_start_data" slot-scope="row">
                                    {{row.item.admin_start_data  | formatMinutes }}
                                </template>
                                <template slot="gofix_table:admin_closure_data" slot-scope="row">
                                    {{row.item.admin_closure_data  | formatMinutes }}
                                </template>
                            </gofix-default-table>
                        </gofix-card>
                        <fault-type :contract_id="Number($route.params.id)" ref="faultType"></fault-type>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-EditPrioritySet" :title=" prioritySetClone && prioritySetClone.priority_options && prioritySetClone.priority_options.length > 0 ? 'Edit Priority' : 'Create Priority'" hide-footer :centered="true" ref="modal-EditPrioritySet" @close="resetDataInDB">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="8">
                        <gofix-form-dropdown
                                label="Clone From Existing Priority Setting"
                                :options="prioritySetMasterList"
                                v-model="prioritySetMaster"
                                vLabel="priority_title">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
                <hr/>
                <gofix-form-input
                        v-for="(option, index) in prioritySetClone && prioritySetClone.priority_options"
                        :key="index"
                        label="priority name"
                        v-model="prioritySetClone.priority_options[index]">
                    <template #gofixInput:text:after-desc>
                        <b-button @click="deletePriorityRight(index)" class="deletePriorityRight">
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.75 5.5H19.25" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M7.33203 5.50065V3.66732C7.33203 3.18109 7.52519 2.71477 7.869 2.37096C8.21282 2.02714 8.67913 1.83398 9.16537 1.83398H12.832C13.3183 1.83398 13.7846 2.02714 14.1284 2.37096C14.4722 2.71477 14.6654 3.18109 14.6654 3.66732V5.50065M17.4154 5.50065V18.334C17.4154 18.8202 17.2222 19.2865 16.8784 19.6303C16.5346 19.9742 16.0683 20.1673 15.582 20.1673H6.41536C5.92913 20.1673 5.46282 19.9742 5.119 19.6303C4.77519 19.2865 4.58203 18.8202 4.58203 18.334V5.50065H17.4154Z" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9.16797 10.084V15.584" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12.832 10.084V15.584" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </b-button>
                    </template>
                </gofix-form-input>
                <gofix-button label="+ add priority" @click="addProritySet" outline></gofix-button>
            </b-form>
            <b-button-group class="text-right d-block">
                <gofix-button label="SUBMIT" @click="updatePrioritySet" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Create Category SLA" hide-footer :centered="true" ref="modal-Create">
            <b-form>
                <gofix-form-tree
                    label="Category Service"
                    :multiple="false"
                    :options="serviceCategories"
                    :load-options="loadOptionServices"
                    search-nested
                    v-model="sla.service_category_id"
                    :normalizer="normalizer">
                </gofix-form-tree>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="save" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import tabData from '@/data/_tabs';
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    const faultType = () => import('./fault-type')

    export default {
        name: 'sla',
        components: {
            faultType
        },
        data() {
            let filter =  JSON.parse(JSON.stringify(filters['sla']));
            return {
                contract_tab:tabData.client_contract,
                tableConfig:{
                    name: 'client-contract-sla',
                    controls:{
                        create: this.$checkRole(this.$accessModule.sla, 'create'),
                        delete: this.$checkRole(this.$accessModule.sla, 'delete'),
                        tableExport: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "name_service",
                    sortDirection: "asc",
                },
                tableItems:[],
                loading: {
                    isServiceLoading: false,
                    isPriorityLoading: false,
                    listing: false
                },
                prioritySetMaster: null,
                normalizer(node) {
                    if (node.isBatch)
                        return {
                            label: node.name,
                            children: node.children
                        };
                    return {
                        label: node.name,
                        children: undefined
                    }
                },
                sla: {
                    reaction_time: 0,
                    response_time: 0,
                    rectification_time: 0,
                    admin_start: 0,
                    admin_closure: 0,
                    priority_set_number: "",
                    service_category_name: null,
                    contract_id: this.$route.params.id
                },
                prioritySetClone: {}
            }
        },
        filters: {
            formatMinutes: function(value) {
                let  date_string = [];
                if(value.days){
                    date_string.push(`${value.days}d`);
                }
                if(value.hours){
                    date_string.push(`${value.hours}h`);
                }
                if(value.minutes){
                    date_string.push(`${value.minutes}m`);
                }
                if(value.seconds){
                    date_string.push(`${value.seconds}s`);
                }
                return date_string.join(" : ") || "--";
            },
        },
        computed: {
            ...mapGetters({
                UserLogin: "AuthController/user",
                serviceCategories: 'v2SlaController/serviceCategories',
                ClientContractID: 'ContractController/ClientContractID',
                prioritySet: 'v2PrioritySetController/prioritySet',
                prioritySetMasterList: 'v2PrioritySetController/prioritySetMasterList',
                currentRoles: 'AuthController/roles',
            }),
        },
        watch: {
            "currentRoles": function(val,old){
                this.tableConfig.controls = {
                    create: this.$checkRole(this.$accessModule.sla, 'create'),
                    delete: this.$checkRole(this.$accessModule.sla, 'delete'),
                }
            },
            ClientContractID: function (val, old) {
                if (!val) {
                    return this.$router.push(`/v2/contract-client`)
                }
                if (val && old && val.id != old.id) {
                    this.sla.contract_id = val.id;
                    this.prioritySetMaster = null;
                    this.getPrioritySet();
                }
            },
            prioritySetMaster: function(val){
                if(val !== null){
                    this.prioritySetClone.priority_options = val.priority_options
                }
            }
        },
        created() {
            if (!this.$route.params.hasOwnProperty("id") || isNaN(this.$route.params.id)) {
                return this.$router.push(`/v2/contract-client`)
            }
            this.loading.isServiceLoading = true;
            this.$store.dispatch('v2SlaController/getServiceCategories', {
                contractId: this.$route.params.id,
                categoryId: 0
            }).then(response => {
                this.loading.isServiceLoading = false;
            });

            this.getPrioritySet();

            this.$store.dispatch('v2PrioritySetController/getPrioritySetMasterList', {})
        },
        methods: {
            resetDataInDB() {
                this.prioritySetClone = JSON.parse(JSON.stringify(this.prioritySet))
            },
            /*---------- Table event ----------*/
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("v2SlaController/getSlaList", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the SLA", "danger");
                        reject();
                    })
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("v2SlaController/deleteSla", ids)
                    .then(response => {
                        this.$refs.faultType.reloadData();
                        resolve(this.$notificationV2('deleting', 'sla'))
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            async newItem(){
                this.resetSla();
                this.$refs['modal-Create'].show()
            },
            async detailItem(item){
                this.$router.push(`/v2/contract-client/${this.$route.params.id}/sla/${item.id}`).catch(err => {})
            },
            /*----------------------------------------*/
            getPrioritySet() {
                this.loading.isPriorityLoading = true;
                this.$store.dispatch('v2PrioritySetController/getPrioritySet', {
                    contract_id: this.$route.params.id
                })
                .then(response => {
                    this.prioritySetClone = JSON.parse(JSON.stringify(response))
                    this.loading.isPriorityLoading = false;
                })
                .catch(err => {
                    this.loading.isPriorityLoading = false;
                });
            },
            resetSla() {
                this.sla.reaction_time =  0;
                this.sla.response_time = 0;
                this.sla.rectification_time = 0;
                this.sla.admin_start = 0;
                this.sla.admin_closure = 0;
                this.sla.priority_set_number = "";
                this.sla.service_category_name = null;
            },
            addProritySet(){
                this.prioritySetClone.priority_options.push("High")
            },
            deletePriorityRight(index){
                this.prioritySetClone.priority_options.splice(index, 1)
            },
            updatePrioritySet(){
                this.$store.dispatch("v2PrioritySetController/updatePrioritySet", this.prioritySetClone
                ).then(async data => {
                    await this.getPrioritySet()
                    await this.$refs['modal-EditPrioritySet'].hide()
                    await this.$alertNotification(this.$notificationV2('editing', 'priority'));
                })
                .catch(error => {
                    if( error.response && error.response.data.error && error.response.data.error.message) {
                        let msg = error.response.data.error.message;
                        this.$alertNotification(msg, "danger");
                    }
                });
            },
            loadOptionServices({action, parentNode, callback}) {
                if (parentNode.isBatch) {
                    this.$store.dispatch("v2SlaController/getServiceCategories", {
                        contractId: this.$route.params.id,
                        categoryId: parentNode.id
                    }).then(data => {
                        parentNode.children = data;
                        callback();
                    })
                } else {
                    callback();
                }

            },
            save() {
                let sla = Object.assign({}, this.sla);

                if (!sla.service_category_id) {
                    return this.$alertNotification("Service is a required field.", "danger");
                }
                this.$store.dispatch('v2SlaController/createSla', {
                    sla: sla,
                })
                .then(result => {
                    this.$alertNotification(this.$notificationV2('adding', 'sla'));
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    this.$refs["modal-Create"].hide();
                })
            },
        }
    }
</script>
